import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=f31cc614&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=f31cc614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31cc614",
  null
  
)

export default component.exports